import React from 'react'
import PropTypes from 'prop-types'

const LogoTuba = ({ className, backgroundFill = '#fff', ...props }) => {
  const uniqueId = React.useId().replace(/:/g, '_')

  return (
    <svg
      width="150px"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${uniqueId}_clip0)`}>
        <path fill={backgroundFill} d="M0 0h30v30H0z" />
        <path
          d="M9.863 15.607v5.094c.29-.369.581-.775.877-1.188.638-.89 1.321-1.844 2.095-2.534v-1.372H9.862z"
          fill={`url(#${uniqueId}_paint0_linear)`}
        />
        <path
          d="M11.08 19.918c-.409.571-.809 1.13-1.217 1.606v3.221h2.972v-7.03c-.618.617-1.191 1.416-1.755 2.203z"
          fill={`url(#${uniqueId}_paint1_linear)`}
        />
        <path
          d="M6.172 19.034v2.395c.393.527.852.868 1.484.868.517 0 1.007-.305 1.49-.779v-2.484H6.171z"
          fill={`url(#${uniqueId}_paint2_linear)`}
        />
        <path
          d="M6.172 24.647c.378.065.774.099 1.187.099h1.786v-2.494c-.467.396-.956.642-1.49.642-.607 0-1.084-.26-1.483-.665v2.418z"
          fill={`url(#${uniqueId}_paint3_linear)`}
        />
        <path
          d="M13.553 12.751v3.69c.463-.28.959-.449 1.495-.449.504 0 1 .113 1.478.307V12.75h-2.973z"
          fill={`url(#${uniqueId}_paint4_linear)`}
        />
        <path
          d="M13.553 17.105v7.64h2.96v.001h.013v-7.815c-.48-.215-.976-.341-1.478-.341-.537 0-1.03.194-1.495.515"
          fill={`url(#${uniqueId}_paint5_linear)`}
        />
        <path
          d="M24.297 14.596c-.122-4.324-1.478-6.122-1.536-6.196-.067-.087-.169-.112-.256-.063-1.59.893-4.525 1.384-8.265 1.384-9.072 0-12.42 1.014-13.134 6.712-.316 2.525.075 4.706 1.132 6.308 1.123 1.702 2.894 2.602 5.121 2.602h9.155v-.597H7.359c-.413 0-.809-.034-1.187-.099-1.529-.26-2.754-1.039-3.582-2.294-.93-1.41-1.294-3.331-1.056-5.569 1.779.117 2.551 1.712 3.3 3.255.392.81.793 1.637 1.338 2.19v-.8c-.342-.46-.634-1.063-.946-1.706-.769-1.586-1.635-3.374-3.616-3.532.368-2.44 1.304-3.852 3.09-4.69 1.792-.84 4.556-1.182 9.54-1.182 3.683 0 6.614-.478 8.291-1.348.303.495 1.207 2.25 1.304 5.647.117 4.141-1.632 6.288-2.196 6.87-.55-.93-2.605-4.174-5.113-5.19v.633c2.666 1.192 4.85 5.1 4.876 5.147.071.13.208.164.312.08.112-.092 2.732-2.298 2.583-7.562z"
          fill="#048B99"
        />
        <path
          d="M12.935 3.939c-1.507 1.234-2.72 2.976-3.508 5.038-.021.057-.003.126.04.154.045.029.099.005.12-.052 1.615-4.225 4.884-6.849 8.532-6.849 2.076 0 3.999.864 5.565 2.328a.491.491 0 00-.016.089c-.018.22.105.418.276.442a.258.258 0 00.205-.067c.74.786 1.387 1.714 1.916 2.75a1.04 1.04 0 00-.29.659c-.043.524.251.994.657 1.05a.583.583 0 00.34-.058c.374 1.057.635 2.193.762 3.383-.554.073-1.034.593-1.162 1.334-.16.925.292 1.842 1.009 2.048.05.014.1.024.15.03-.129 1.187-.39 2.32-.763 3.373a.584.584 0 00-.336-.055c-.406.055-.7.525-.657 1.05.023.27.13.5.284.653a11.862 11.862 0 01-1.918 2.748.256.256 0 00-.197-.06c-.17.024-.294.222-.276.443.002.026.006.05.012.075-1.565 1.462-3.486 2.325-5.561 2.325a7.584 7.584 0 01-3.113-.673c-.047-.021-.098.011-.114.071s.009.126.055.146A7.726 7.726 0 0018.12 27c2.111 0 4.067-.877 5.66-2.363a.265.265 0 00.231.09c.171-.024.295-.221.277-.442a.485.485 0 00-.028-.125c.755-.801 1.414-1.747 1.953-2.803a.59.59 0 00.377.077c.406-.056.7-.526.657-1.05a1.024 1.024 0 00-.32-.688 15.22 15.22 0 00.785-3.47c.593-.023 1.122-.558 1.257-1.34.16-.926-.292-1.843-1.01-2.049a1.047 1.047 0 00-.244-.039 15.233 15.233 0 00-.783-3.482c.17-.152.291-.396.315-.683.043-.524-.251-.994-.657-1.05a.589.589 0 00-.37.073c-.54-1.06-1.2-2.008-1.956-2.811a.49.49 0 00.024-.113c.018-.221-.106-.419-.277-.443a.263.263 0 00-.222.082C22.193 2.881 20.234 2 18.118 2c-1.842 0-3.634.67-5.183 1.939"
          fill={`url(#${uniqueId}_paint6_linear)`}
        />
      </g>
      <defs>
        <linearGradient
          id={`${uniqueId}_paint0_linear`}
          x1={13.822}
          y1={5.743}
          x2={7.691}
          y2={21.445}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#048B99" />
        </linearGradient>
        <linearGradient
          id={`${uniqueId}_paint1_linear`}
          x1={15.291}
          y1={6.316}
          x2={9.16}
          y2={22.019}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#048B99" />
        </linearGradient>
        <linearGradient
          id={`${uniqueId}_paint2_linear`}
          x1={11.297}
          y1={4.757}
          x2={5.166}
          y2={20.459}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#048B99" />
        </linearGradient>
        <linearGradient
          id={`${uniqueId}_paint3_linear`}
          x1={11.986}
          y1={5.026}
          x2={5.855}
          y2={20.729}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#048B99" />
        </linearGradient>
        <linearGradient
          id={`${uniqueId}_paint4_linear`}
          x1={16.823}
          y1={6.915}
          x2={10.692}
          y2={22.617}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#048B99" />
        </linearGradient>
        <linearGradient
          id={`${uniqueId}_paint5_linear`}
          x1={18.198}
          y1={7.451}
          x2={12.067}
          y2={23.154}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#048B99" />
        </linearGradient>
        <linearGradient
          id={`${uniqueId}_paint6_linear`}
          x1={9.584}
          y1={17.001}
          x2={28.247}
          y2={13.717}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7DDBDB" />
          <stop offset={1} stopColor="#FD7234" />
        </linearGradient>
        <clipPath id={`${uniqueId}_clip0`}>
          <path fill="#fff" d="M0 0h30v30H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

LogoTuba.propTypes = {
  className: PropTypes.string,
  backgroundFill: PropTypes.string,
}

export default LogoTuba
